import React from 'react';

function Chess123Privacy(props) {
    return (
        <div className='Privacy'>
            <h1>123 Chess — Privacy Policy</h1>
            <p><i>Last updated: October 25, 2025</i></p>
            <p></p>
            <p>This Privacy Policy describes how Lockwood Productions, LLC ("we," "us," or "our") handles information in the 123 Chess mobile application ("the App").</p>
            <p></p>

            <h2>Our approach to privacy</h2>
            <p></p>
            <p>123 Chess is designed to be a calm, safe learning experience. The App does not collect personal information, connect to the internet, or require any kind of account. Your child's activity stays entirely on the device.</p>
            <p></p>

            <h2>Information we collect</h2>
            <p></p>
            <ul>
                <li><strong>No personal data:</strong> The App does not ask for or store names, email addresses, or any other identifying details.</li>
                <li><strong>No online services:</strong> The App does not send or receive data over the internet.</li>
                <li><strong>Third-party software:</strong> The App includes certain third-party software libraries (for example, for graphics and animation). These tools run locally on your device and do not transmit information externally.</li>
                <li><strong>Analytics provided by Apple:</strong> We may see limited, anonymous information that Apple provides to developers if you have chosen to share analytics with app developers through your Apple device settings. This information is aggregated and cannot be used to identify you.</li>
            </ul>
            <p></p>

            <h2>Purchases and accounts</h2>
            <p></p>
            <p>123 Chess is a paid app purchased through Apple's App Store. We do not handle or store any payment information; all transactions are managed by Apple under its own privacy and security policies. The App does not include in-app purchases or subscriptions and does not require account creation or sign-in.</p>
            <p></p>

            <h2>Device permissions</h2>
            <p></p>
            <p>The App does not request access to your camera, microphone, photos, contacts, or location.</p>
            <p></p>

            <h2>Children's privacy</h2>
            <p></p>
            <p>We take the privacy of families seriously. 123 Chess is built so that children can learn and play safely, without sharing information. Parents can contact us anytime with questions or concerns.</p>
            <p></p>

            <h2>Changes to this policy</h2>
            <p></p>
            <p>We may update this Privacy Policy from time to time. Any updates will be posted with a new "Last updated" date.</p>
            <p></p>

            <h2>Contact us</h2>
            <p></p>
            <p>If you have questions about this Privacy Policy or how 123 Chess handles information, please contact:</p>
            <p></p>
            <p>Lockwood Productions, LLC<br />
            Email: chesstacticsapp@gmail.com<br />
            Based in Washington, USA</p>
        </div>
    );
}

export default Chess123Privacy;



// WEBPACK FOOTER //
// ./src/Chess123Privacy.js